import { useI18n } from 'vue-i18n';
import { OrderMethods } from '@centric-os/types';
import * as yup from 'yup';

const useStationSchema = (isCreate = false) => {
  const { t } = useI18n();

  const defaultSchema = yup.object().shape({
    id: yup.string().optional().nullable(),
    name: yup.string().required(t('errorMessages.required')),
    location: yup.string().required(t('errorMessages.required')),
    location_description: yup.string().nullable().optional(),
    external_id: yup.string().nullable().optional(),
    style: yup.object().shape({
      alt_logo: yup.string().nullable(),
      logo: yup.string().nullable(),
      main_logo: yup.string().nullable(),
    }),
    is: yup.object().shape({
      frictionless_supported: yup.boolean().nullable().optional(),
      scan_and_go_supported: yup.boolean().nullable().optional(),
    }),
    meta: yup.object().shape({
      software_integrations: yup.object().shape({
        jwo: yup.string().nullable().optional(),
        system365: yup.string().nullable().optional(),
        time2eat: yup
          .object({
            enabled: yup.boolean(),
            use_timeslots: yup.boolean(),
            ignore_station_hours: yup.boolean(),
          })
          .optional(),
        agilysys: yup
          .object({
            order_streaming_enabled: yup.boolean(),
          })
          .optional(),
      }),
    }),
    ...(isCreate && {
      orderMethod: yup
        .string()
        .required(t('errorMessages.required'))
        .oneOf(
          Object.values(OrderMethods),
          t('errorMessages.invalidType', { type: Object.values(OrderMethods).join(', ') }),
        ),
    }),
  });

  return {
    defaultSchema,
  };
};

export default useStationSchema;
